import React from 'react'
import { useTrans } from 'hooks'
import { Breadcrumbs, WContainer } from '@components/atoms'
import { FormContattaci, Page } from 'components/organisms'
import styles from './ContattaciTemplate.module.sass'
import { PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
}

const ContattaciTemplate = ({ pagina }: Props) => {
  const t = useTrans()
  return (
    <Page pagina={pagina} item={pagina}>
       <WContainer>
        <div className={styles.breadcrumbs}>
          <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        </div>
      </WContainer>
      <WContainer variant="xs">
        <div className={styles.main}>
          <h1 className={styles.title}>{pagina.titolo}</h1>
          <div
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: pagina.descrizione,
            }}
          />
          <FormContattaci site={pagina.site}/>
        </div>
      </WContainer>
    </Page>
  )
}

export default ContattaciTemplate
